const inline = (s) =>
  s.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") && part.endsWith("**") ? (
      <strong key={i} className="font-semibold text-black">{part.slice(2, -2)}</strong>
    ) : (
      part
    )
  );

const renderLine = (l, key) => {
  if (l.startsWith("# ")) {
    return <h1 key={key} className="text-[36px] font-bold leading-tight tracking-[-0.02em] text-black lg:text-[48px]">{l.slice(2)}</h1>;
  }
  if (l.startsWith("## ")) {
    return <h2 key={key} className="mt-10 text-xl font-bold text-black lg:text-2xl">{l.slice(3)}</h2>;
  }
  if (/^\*\*[^*]+\*\*$/.test(l)) {
    return <h3 key={key} className="mt-6 text-base font-bold text-black">{l.slice(2, -2)}</h3>;
  }
  return <p key={key} className="mt-2">{inline(l)}</p>;
};

// Renders the small markdown subset used by the legal texts (#, ##, **bold**, - lists).
export const Prose = ({ md, testid }) => {
  const out = [];
  let list = [];
  const flush = () => {
    if (list.length) {
      out.push(<ul key={`ul-${out.length}`} className="mt-3 list-disc space-y-2 pl-5 marker:text-zinc-500">{list}</ul>);
      list = [];
    }
  };
  md.trim().split("\n").forEach((raw, i) => {
    const l = raw.trim();
    if (l.startsWith("- ")) {
      list.push(<li key={i}>{inline(l.slice(2))}</li>);
      return;
    }
    flush();
    if (l) out.push(renderLine(l, i));
  });
  flush();
  return (
    <div className="text-base leading-relaxed text-zinc-700" data-testid={testid}>
      {out}
    </div>
  );
};
